window.optionWidthLastValue = window.optionWidthLastValue || null;
window.optionWidthPendingSliderValue = window.optionWidthPendingSliderValue ?? null;
window.optionWidthPendingSliderLeft = window.optionWidthPendingSliderLeft ?? null;

class OptionWidthRange extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      container: '.length-range',
    };
    if (this.dataset.range == 'false') { return; }
    this.init();
  }

  init() {
    this.container = this.querySelector(this.selectors.container);
    this.isInitializing = true;

    if (!this.container) return;

    this.parseData();
    if (this.widthValues.length === 0 || this.productHandles.length === 0) return;

    this.completeInitialization();
  }

  parseData() {
    const widthValuesStr = this.container.dataset.widthValues || '';
    const productHandlesStr = this.container.dataset.productHandles || '';
    this.widthStyle = this.container.dataset.type || 'default';

    this.widthValues = widthValuesStr.split(',').map(v => parseFloat(v.trim()));
    this.productHandles = productHandlesStr.split(',').map(h => h.trim());
  }



  completeInitialization() {
    setTimeout(() => {
      this.isInitializing = false;
    }, 100);
  }



  debounceFetchAndUpdateProduct(productHandle, delay = 400) { 
    if (this._fetchDebounceTimer) {
      clearTimeout(this._fetchDebounceTimer);
    }
    this._fetchDebounceTimer = setTimeout(() => {
      this.fetchAndUpdateProduct(productHandle);
    }, delay);
  } 

  async fetchAndUpdateProduct(productHandle) {
    try {
      this.classList.add('loading');
      this.showLoader();
      
      // Update URL first
      const newUrl = `/products/${productHandle}`;
      window.history.pushState({ productHandle }, '', newUrl);
      
      // Simply reload the page with the new URL
      // This is the cleanest approach - no custom element conflicts, no script reloading issues
      window.location.reload();
      
    } catch (error) {
      console.error('Error fetching product:', error);
      window.location.href = `/products/${productHandle}`;
    }
  }

  showLoader() {
    const loader = document.getElementById('product-width-loader');
    if (loader) {
      loader.style.display = 'flex';
    }
  }

  hideLoader() {
    const loader = document.getElementById('product-width-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }
}

customElements.define('option-width-range', OptionWidthRange);
 